export const POOR_CONNECTION_DEBOUNCE_MS = 15000
